/**
 * @file   src\components\CWInput.tsx
 * @brief  Input with label component.
 * @date   Jun, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import { InputProperty } from '../interfaces/generalInterface';
import { Form } from '../utils/thirdpartyComponents';
import "../components/CWInput.scss";

const CWRadio = ({
  onChange,
  onBlur,
  onFocus,
  onKeyPress,
  label,
  isMandatory,
  autoFocus,
  errorMessage,
  value,
  id,
  name,
  type,
  accept,
  pattern,
  placeholder,
  disabled,
  maxLength,
  step,
  checked
}: InputProperty) => {

  return (
    <div className="form-group cw-check">
      <Form.Check
        name={name}
        type="radio"
        id={id}
        onChange={onChange}
        disabled={disabled}
        label={label}
        checked={checked}
        value={value}
      />
      {errorMessage && errorMessage !== '' && <span className="error-msg">{errorMessage}</span>}
    </div>
  );
};

export default CWRadio;
